function fireKnowledgeCampusConversion() {
  const { kcImpId, kcAdId, rtb, q } = this.pageParams;
  const knowledgeCampus = this.doc.createElement('image');
  knowledgeCampus.src = `//trk.clickmeasurement.net/conversion.gif?cid=${kcImpId}`;
  knowledgeCampus.width = "1px";
  knowledgeCampus.height = "1px";

  var kcAdClick = this.doc.createElement('image');
  kcAdClick.src = `//clickmapping.com/do?event_name=domainswap&keyword=${q.replace(/\s/g, '+')}&adid=${kcAdId}&referrer=${this.win.location.hostname}&subid1=${rtb}`;
  kcAdClick.width = "1px";
  kcAdClick.height = "1px";

  this.doc.head.append(knowledgeCampus);
  this.doc.head.append(kcAdClick);
}

module.exports = {
  fireKnowledgeCampusConversion,
};
